import { IntegrationServiceId } from './integrations'

/** Meeting providers that require the user to have a connected (live) integration. */
export const INTEGRATIONS_REQUIRING_USER_CONNECTION = new Set([IntegrationServiceId.ZOOM])

export interface IntegrationRequirementResult {
  satisfied: boolean
  accountAllowed: boolean
}
